import React from 'react'
import PropTypes from 'prop-types'
import {
  Typography,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core'

import { BaseDialog } from 'components'
import { Controller, useForm } from 'react-hook-form'

import schema from './schema'

const EvaluateLargeScaleDialog = ({ open, onClose, onSubmit }) => {
  const { control, errors, handleSubmit } = useForm({
    validationSchema: schema,
    defaultValues: {
      isLargeScale: '',
    },
  })

  return (
    <BaseDialog
      open={open}
      setOpen={onClose}
      title="Avaliação de Larga Escala"
      dialogSize="sm"
      fullWidth
      closeButtonText="Cancelar"
      actionButtonText="Confirmar"
      actionButton={handleSubmit(onSubmit)}
      preventCloseOnBackdropClick={true}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5" style={{ fontWeight: 400 }}>
            A avaliação de Larga Escala ajuda a determinar a magnitude do
            tratamento, levando em consideração a quantidade de titulares de
            dados, a frequência, a duração e a extensão geográfica do
            tratamento.
          </Typography>
          <Typography
            variant="h5"
            style={{ fontWeight: 900, paddingTop: 16, paddingBottom: 8 }}
          >
            Após a análise, você considera o tratamento em larga escala? A
            questão surgiu ao responder sobre o tema.
          </Typography>
          <Controller
            name="isLargeScale"
            control={control}
            defaultValue=""
            as={
              <RadioGroup row name="isLargeScale">
                <FormControlLabel
                  value="yes"
                  control={<Radio color="primary" />}
                  label="Sim"
                />
                <FormControlLabel
                  value="no"
                  control={<Radio color="primary" />}
                  label="Não"
                />
              </RadioGroup>
            }
          />
          {errors?.isLargeScale && (
            <Typography color="error">{errors.isLargeScale.message}</Typography>
          )}
        </Grid>
      </Grid>
    </BaseDialog>
  )
}

EvaluateLargeScaleDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default EvaluateLargeScaleDialog
